(function () {
    'use strict';

    angular.module('app').controller('ToolbarController', ToolbarController).directive('toolbar', Toolbar);

// Controller
    ToolbarController.$inject = [
        '$scope',
        '$rootScope',
        '$translate',
        '$location',
        'LANGS',
        'UserService',
        'BusinessService',
        'NotifyService'];

    function ToolbarController($scope, $rootScope, $translate, $location, LANGS, UserService, BusinessService, NotifyService) {

        $scope.LANGS = LANGS;
        $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';
        $scope.isTmyasa = appConfig.platformParams.main_site.en === 'tmyasa.com.ua';
        $scope.isGLO = appConfig.platformParams.main_site.en === 'myglo.com.ua';
        $scope.isParimatch = appConfig.platformParams.main_site.en === 'pmclub.bet';


        $scope.getLocalizedPath = getLocalizedPathFromUrlByLang;

        $scope.hideLogoutIcon = $location.path().includes('wizard')

        // if ($cookies.get("NG_TRANSLATE_LANG_KEY"))
        //     $scope.currentLang = $cookies.get("NG_TRANSLATE_LANG_KEY").replace(/\"/g, '');
        // else
        //     $scope.currentLang = $translate.use();

        $scope.Logout = function () {
            UserService.Logout();
        };

        $scope.toggleSidebar = function () {
            $rootScope.PAGE.style = 'admin-panel page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-content-white';
            // $rootScope.ENV.sidebarCollapsed = $cookies.get('sidebar_closed') == '0' || $cookies.get('sidebar_closed') == undefined;
            if (!$rootScope.ENV.sidebar) {
                $rootScope.ENV.sidebar = 1;
                $rootScope.PAGE.style += ' page-sidebar-closed';
            } else {
                $rootScope.ENV.sidebar = 0;
            }

            // $rootScope.fixContenTheight();
            $rootScope.storeENV();

            console.info('init toggle', $rootScope.ENV.sidebarCollapsed);
        };

        /**
         * Change current interface language
         */
        $scope.onChangeLanguage = function (langKey) {
            console.info('Lang', langKey);
            $translate.use(langKey);
            if ($rootScope.USER && $rootScope.USER.Authorized) {
                UserService.ChangeLanguage({language: langKey}, function () {
                    $scope.currentLang = langKey;
                    if (appConfig.platformParams.helpcrunch) {
                        window.HelpCrunch('setPhraseList', langKey);
                    }
                });
            }
        };

        $scope.trialDaysLeft = function (date) {
            var nowDate = moment(),
                endDate = moment(date);
            return endDate.diff(nowDate, 'days')+1;
        }
    }

// Directive    
    Toolbar.$inject = [];

    function Toolbar() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/toolbar.html',
            link: function (scope, element, attrs) {
            }
        };
    }
})();
